const symbols = {
  EUR: '€',
  USD: '$',
  GBP: '£'
}

export default symbols
